import {mapGetters} from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtSaleProceedsNew from '@/common/components/mvtsaleproceeds/mvt-saleproceedsnew.vue';

export default {
    name: 'propertySaleProceedsNew',
    data() {
        return {
            disableCollapse: false,
            netProceeds: 0,
            isMounted: false,
        };
    },
    components: {
        mvtCollapse,
        mvtSaleProceedsNew,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getEstPrice', 'getAvmValuation']),
    },
    props: ['isActive'],
    methods: {
        updateNetProceeds(value) {
            this.netProceeds = value;
        },
    },
    mounted() {
        this.isMounted = true;
    },
};
